import * as Yup from "yup";
import form from "./form";

const {
  formField: {
    name,
    description,
    clientId,
    budget,
    actualExpenditure,
    startedDate,
    endedDate,
    budgetStatus,
    projectStatus,
    categoryId,
    progress,
    changeRequestCount,
    file,
    companyId,
  },
} = form;

const validations = [
  Yup.object().shape({
    [name.name]: Yup.string().required(name.errorMsg),
    [description.name]: Yup.string().required(description.errorMsg),
    [clientId.name]: Yup.string(),

    [startedDate.name]: Yup.date().required(startedDate.errorMsg),
    [endedDate.name]: Yup.date().required(endedDate.errorMsg),

    [projectStatus.name]: Yup.string().required(projectStatus.errorMsg),
    [categoryId.name]: Yup.string(),
    [progress.name]: Yup.number().required(progress.errorMsg).min(0).max(100),
    [changeRequestCount.name]: Yup.number().required(changeRequestCount.errorMsg).min(0),
    [companyId.name]: Yup.string(),
  }),
  Yup.object().shape({
    [budget.name]: Yup.number().required(budget.errorMsg).min(0),
    [actualExpenditure.name]: Yup.number().required(actualExpenditure.errorMsg).min(0),
    [budgetStatus.name]: Yup.number().required(budgetStatus.errorMsg),
  }),
  Yup.object().shape({
    // يمكن إضافة validation للملفات هنا إذا لزم الأمر
    // [file.name]: Yup.mixed().required("A file is required"),
  }),
];

export default validations;
